<div class="report-item text-center">
  <div class="report-details" [ngClass]="{ selected: details.selected }">
    <div class="container-fluid">
      <div class="row align-items-center py-3">
        <div class="col-12 col-sm-6 col-md-8">
          <h2 class="title">
            {{ details.reportName }}
          </h2>
          <p class="description mb-0">
            {{ details.reportDescription }}
          </p>
        </div>
        <div class="col-12 col-md-2">
          <img
            [src]="details.thumbnailLink"
            [alt]="details.reportName"
            style="height: 3.75rem" />
        </div>
        <div class="col-12 col-md-2 action">
          <button
            *ngIf="details.selected"
            mat-stroked-button
            color="accent"
            (click)="onReportClick()">
            Selected
          </button>
          <button
            *ngIf="!details.selected"
            mat-flat-button
            color="accent"
            (click)="onReportClick()"
            class="rounded">
            Select
          </button>
        </div>
      </div>
    </div>
  </div>
  <div class="filters pa-6" [@slideInOut]="slide">
    <app-dynamic-form
      [reportFilters]="details.reportFilters"
      submitButtonText="Run Report"
      (onFormSubmit)="onFormSubmit($event)"></app-dynamic-form>
  </div>
</div>
